import axios from './axios-instance'

export default {
  all ({ q = '' }) {
    return axios.get(`/v1/training_methods?q=${q}`)
  }
}
